import { isEmpty } from 'lodash';

export function buildAddressLine1(parcelProperties: any) {
  let addressLine = '';
  if (!isEmpty(parcelProperties.saddno)) {
    addressLine += ` ${parcelProperties.saddno}`;
  }
  if (!isEmpty(parcelProperties.saddpref)) {
    addressLine += ` ${parcelProperties.saddpref}`;
  }
  if (!isEmpty(parcelProperties.saddstr)) {
    addressLine += ` ${parcelProperties.saddstr}`;
  }
  if (!isEmpty(parcelProperties.saddsttyp)) {
    addressLine += ` ${parcelProperties.saddsttyp}`;
  }
  if (!isEmpty(parcelProperties.saddstsuf)) {
    addressLine += ` ${parcelProperties.saddstsuf}`;
  }
  if (!isEmpty(parcelProperties.sunit)) {
    addressLine += ` ${parcelProperties.sunit}`;
  }
  return addressLine;
}

export function buildCityStateLine(parcelProperties: any) {
  let addressLine = '';
  if (!isEmpty(parcelProperties.scity)) {
    addressLine += `${parcelProperties.scity}, `;
  }
  if (!isEmpty(parcelProperties.state2)) {
    addressLine += `${parcelProperties.state2.toUpperCase()} `;
  }
  if (!isEmpty(parcelProperties.szip)) {
    addressLine += `${parcelProperties.szip}`;
  }
  return addressLine;
}

export function buildAddressLine(parcelProperties: any) {
  let addressLine = buildAddressLine1(parcelProperties);
  if (!isEmpty(parcelProperties.address2)) {
    addressLine += `${parcelProperties.address2}, `;
  }
  if (!isEmpty(addressLine)) {
    addressLine += ' ';
  }
  addressLine += buildCityStateLine(parcelProperties);
  return addressLine;
}
